import { render, staticRenderFns } from "./_BroadcastsOverviewPanel.vue?vue&type=template&id=27396705&scoped=true&"
import script from "./_BroadcastsOverviewPanel.vue?vue&type=script&lang=js&"
export * from "./_BroadcastsOverviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastsOverviewPanel.vue?vue&type=style&index=0&id=27396705&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27396705",
  null
  
)

export default component.exports